var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_166_2089",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H64V64H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_166_2089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6401 10.7644L0.167974 47.5166C-0.0124524 47.8816 -0.0416859 48.303 0.086616 48.6894C0.214918 49.0758 0.490406 49.396 0.853311 49.5806L10.808 54.5833C11.173 54.7648 11.5948 54.7948 11.9818 54.667C12.3688 54.5392 12.6897 54.2638 12.8747 53.9006L31.3441 17.1484C31.5254 16.7832 31.5551 16.3611 31.4267 15.9741C31.2984 15.587 31.0224 15.2664 30.6588 15.0818L20.7041 10.0817C20.5236 9.99098 20.327 9.9367 20.1255 9.92203C19.924 9.90735 19.7216 9.93257 19.5299 9.99623C19.3382 10.0599 19.1609 10.1607 19.0082 10.293C18.8555 10.4253 18.7304 10.5864 18.6401 10.7671V10.7644Z",
    fill: "url(#paint0_linear_166_2089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3199 10.2188H62.464C63.312 10.2188 64.0027 10.9121 64.0027 11.7574V52.891C64.0013 53.2989 63.8388 53.6897 63.5506 53.9784C63.2624 54.267 62.8719 54.4302 62.464 54.4323H51.3199C50.912 54.4302 50.5215 54.267 50.2333 53.9784C49.9451 53.6897 49.7827 53.2989 49.7812 52.891V11.7601C49.7812 10.9121 50.4719 10.2188 51.3199 10.2188Z",
    fill: "url(#paint1_linear_166_2089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1768 10.8943L26.2701 50.9559C26.1931 51.3552 26.2768 51.7688 26.503 52.1069C26.7292 52.4449 27.0796 52.68 27.4781 52.7612L38.3982 54.9639C39.2355 55.1319 40.0515 54.5905 40.2142 53.7532L48.1182 13.6943C48.1945 13.295 48.1106 12.8818 47.8845 12.5439C47.6584 12.206 47.3084 11.9708 46.9102 11.889L35.9875 9.68364C35.5866 9.60435 35.1705 9.68726 34.8306 9.9142C34.4907 10.1411 34.2573 10.4936 34.1768 10.8943Z",
    fill: "url(#paint2_linear_166_2089)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_166_2089",
    x1: 4.00266,
    y1: 52.002,
    x2: 32.0028,
    y2: 0.00169641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#E90CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#C023ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#B02DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B02DE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_166_2089",
    x1: -0.000334296,
    y1: 64.0004,
    x2: 64,
    y2: 0.0000311708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B02DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#B02DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#6D00CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D00CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_166_2089",
    x1: 0.00333389,
    y1: 64.0013,
    x2: 64.0037,
    y2: 0.000941483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FF00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E90CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#C023ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#B02DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A42BE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#8626D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#6021C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6021C3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMake);
export default __webpack_public_path__ + "static/media/make.bcf598efe2e3983570b526dc427207b2.svg";
export { ForwardRef as ReactComponent };